enum DocumentState {
    draft = "draft",
    finished  = "finished",
    public = "public"
  }
  
export default DocumentState;